import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

/**
 * La píldora "Información validada" del diseño: una casilla dentro de una caja
 * que se pone verde al marcarla.
 *
 * Dice "una PERSONA revisó este texto", que es lo único que distingue uno leído
 * de uno que propuso la IA. Es la misma de Descripción de suelos y de
 * Descripción de la propiedad; `etiqueta` es el nombre accesible de la casilla,
 * para que varias en la misma pantalla se distingan.
 */
export function PildoraDeValidacion({
  validada,
  etiqueta,
  disabled,
  onValidada,
}: {
  validada: boolean;
  etiqueta: string;
  disabled?: boolean;
  onValidada: (validada: boolean) => void;
}) {
  return (
    <label
      className={cn(
        "flex h-8 w-fit cursor-pointer items-center gap-2 rounded-[0.625rem] border-[1.5px] px-[0.6875rem] text-[0.71875rem] font-bold",
        validada
          ? "bg-success-soft/50 border-success-dot/40 text-success-soft-foreground"
          : "bg-background text-ink-muted",
      )}
    >
      <Checkbox
        checked={validada}
        disabled={disabled}
        className="size-[0.9375rem] rounded-[0.3125rem] [&_svg]:size-2.5"
        aria-label={etiqueta}
        onCheckedChange={(v) => onValidada(v === true)}
      />
      Información validada
    </label>
  );
}
